<template>
  <div id="page-expense-category-list">
    <div class="vx-card p-6">
      <vs-table
        id="table-loading"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        pagination
        :max-items="length"
        search
        :data="histories"
      >
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="product_histories.id">Sr#</vs-th>
          <vs-th sort-key="product_histories.transactionType">Transaction Type </vs-th>
          <vs-th sort-key="product_histories.weight_type">Weight Type</vs-th>
          <vs-th sort-key="product_histories.changesInQuantity">Change In Quantity</vs-th>
          <vs-th sort-key="user.username">Created By</vs-th>
          <vs-th sort-key="product_histories.created_at">Date</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ tr.transactionType === 'Credit' ? 'Add' : tr.transactionType }}
            </vs-td>
            <vs-td>
              {{ tr.product.weight_type }}
            </vs-td>
            <vs-td>
              {{ [categories.FLOWER, categories.SHAKE].includes(tr.categoryId) ? convertAvailableQty(tr.changesInQuantity, 'pounds')[tr.product.weight_type] : tr.changesInQuantity | weightFilter }}
            </vs-td>
            <vs-td>
              {{ tr.user && tr.user.username }}
            </vs-td>
            <vs-td>
              {{ formatDateTime(tr.created_at) }}
            </vs-td>
            <vs-td>
              <div class="inline-flex" v-if="checkPermissionByIds([permissions.PRODUCT_EDIT])" :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                <vx-tooltip v-if="checkPermissionByIds([permissions.PRODUCT_EDIT])" text="Update quantity">
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="showDialog(tr)" color="primary" type="border" />
                </vx-tooltip>
              </div>
              <div v-else>-</div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <vs-popup id="update-product-quantity-popup" class="vs-con-loading__container" title="Update quantity" button-accept="false" button-cancel="false" :active.sync="activePrompt">
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          How much quantity are you adding or removing?
          <vs-input
            :value="quantity"
            @input="(int) => (quantity = int)"
            v-validate="'required|not_zero'"
            type="number"
            step="0.001"
            data-vv-validate-on="change|blur"
            name="Quantity"
            class="vx-col w-full"
            @change="(event) => (quantity = mathRound(event.target.value ? parseFloat(event.target.value) : 0, 3))"
          />
          <span class="text-danger text-sm" v-show="errors.has('Quantity')">{{ errors.first('Quantity') }}</span>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col w-full">
          <div class="float-right">
            <vs-button class="mr-2" type="relief" @click="saveQuantity" :disabled="!validateForm">Save Changes</vs-button>
            <vs-button to="/products/list" color="danger" @click=";(activePrompt = false), (quantity = 0)" type="relief" class="text-left">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { weightMixins } from '@/utils/weightType'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'HistoricalList',
  data: () => ({
    order: [],
    length: 10,
    page: 1,
    search: '',
    activePrompt: false,
    quantity: 0,
    id: null,
    changesInQuantity: 0,
    processing: false
  }),
  mixins: [weightMixins, dateMixins],

  mounted() {
    this.getData()
  },

  computed: {
    ...mapState('product', {
      histories: 'product-historical',
      total: 'product-total',
      loading: 'product-loading',
      FilteredCount: 'product-FilteredCount',
      categories: 'categories'
    }),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds']),
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    ...mapActions('product', { getHistoricalList: 'getProductHistoricalList', updateHistoryQuantity: 'updateHistoryQuantity' }),
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },
    getData() {
      const { page, length, order, search } = this
      this.getHistoricalList({
        id: this.$route.params.id,
        data: {
          page,
          limit: length,
          order,
          search
        }
      })
    },
    async saveQuantity() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fill the Quantity',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      try {
        this.processing = true
        const { message } = await this.updateHistoryQuantity({
          id: this.id,
          data: {
            quantity: weightMixins.methods.mathRound(this.quantity, 3)
          }
        })
        this.processing = false
        this.activePrompt = false
        this.quantity = 0
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.processing = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    showDialog(tr) {
      this.activePrompt = true
      this.id = tr.id
      this.changesInQuantity = weightMixins.methods.mathRound(tr.changesInQuantity, 3)
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#table-loading',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#table-loading > .con-vs-loading')
      }
    },
    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#update-product-quantity-popup',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-product-quantity-popup > .con-vs-loading')
      }
    }
  },
  created() {
    this.$validator.extend('not_zero', {
      getMessage: (field) => `${field} can't be zero.`,
      validate: (value) => value !== 0
    })
  },

  // filters
  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  },

  beforeRouteLeave(_, __, next) {
    this.activePrompt = false
    next()
  }
}
</script>
